const queue = [];

/**
 *
 * @param {Array} cmd
 */
export const queueTpCommand = (cmd) => {
  queue.push(cmd);
};

/**
 *
 * @param {Function} tpPush
 */
export function flushTpCommands(tpPush) {
  if (!queue.length) return;

  const tagSet = new Set(); // union of all tag arrays
  const latest = new Map(); // single-value key  -> last cmd
  const restV = []; // everything else

  const SINGLE_KEYS = new Set([
    'setContentCreated',
    'setContentAuthor',
    'setContentSection',
    'setContentIsNative',
  ]);

  queue.forEach(([key, ...rest]) => {
    if (key === 'setTags') {
      const tags = Array.isArray(rest[0]) ? rest[0] : [rest[0]];
      tags.forEach((t) => tagSet.add(t));
    } else if (SINGLE_KEYS.has(key)) {
      latest.set(key, [key, ...rest]);
    } else {
      restV.push([key, ...rest]);
    }
  });

  if (tagSet.size) {
    tpPush(['setTags', [...tagSet]]);
  }

  latest.forEach((cmd) => tpPush(cmd)); // publish date, author, etc.
  restV.forEach(tpPush); // custom variables, zones…

  queue.length = 0;
}
